__turbopack_context__.v({
  "animatedText": "style-module-scss-module__-REI7W__animatedText",
  "circle": "style-module-scss-module__-REI7W__circle",
  "curvedContainer": "style-module-scss-module__-REI7W__curvedContainer",
  "curvedText": "style-module-scss-module__-REI7W__curvedText",
  "curvedWrapper": "style-module-scss-module__-REI7W__curvedWrapper",
  "wrapper": "style-module-scss-module__-REI7W__wrapper",
});
